import { Wordmark } from '../components/Logo'
import { btnPrimary } from '../lib/ui'

const STEPS: { n: number; title: string; body: string }[] = [
  { n: 1, title: 'つくる', body: 'イベント名を入れ、カレンダーをタップして候補日を選ぶだけ。ログイン不要、30秒で完成。' },
  { n: 2, title: '共有する', body: '発行されたリンクを送るだけ。リンクを知っていれば誰でも回答・編集できます。' },
  { n: 3, title: '回答する', body: '名前を入れ、各候補に ○（参加）/ △（未定）/ ✕（不可）を選んで送信。コメントも添えられます。' },
  { n: 4, title: '集計を見る', body: '日程×参加者の表で全員の出欠が一目瞭然。最有力の日程には ★ が付きます。' },
  { n: 5, title: '予定をまとめて見る', body: 'この端末で開いた複数イベントでの自分の回答を、マイ予定で横断的に確認できます。' },
]

export default function About() {
  return (
    <div className="animate-in mx-auto max-w-2xl px-4 pb-16 pt-5">
      <header className="mb-7 flex items-center justify-between">
        <a href="/" aria-label="トップへ">
          <Wordmark />
        </a>
        <a href="/me" className="rounded-lg px-2.5 py-1.5 text-sm font-medium text-muted transition hover:bg-brand-soft hover:text-brand-ink">
          マイ予定
        </a>
      </header>

      <h1 className="font-display text-3xl font-bold leading-tight tracking-tight text-ink">
        使い方 ＆ デモ
      </h1>
      <p className="mt-3 text-[15px] leading-relaxed text-muted">
        <b className="text-ink">ヨテピース</b> は、ログイン不要のかんたん日程調整ツール。出欠の集計に加えて、
        <b className="text-ink">複数イベントでの自分の回答</b>を、マイ予定でまとめて確認できます。
      </p>

      <div className="mt-7 rounded-2xl border border-brand/15 bg-brand-soft/60 p-6 text-center">
        <p className="font-semibold text-ink">まずは見本をどうぞ</p>
        <p className="mb-4 mt-1 text-xs text-muted">
          集計表とマイ予定の見本です。保存はされず、あなたのデータも汚しません。
        </p>
        <a href="/demo" className={`${btnPrimary} px-8 py-3 text-base`}>
          デモを見る
        </a>
      </div>

      <ol className="mt-8 space-y-2.5">
        {STEPS.map((s) => (
          <li key={s.n} className="flex gap-3.5 rounded-2xl border border-line bg-surface p-4">
            <span className="font-display flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-brand text-sm font-bold text-white">
              {s.n}
            </span>
            <div>
              <div className="font-semibold text-ink">{s.title}</div>
              <p className="mt-0.5 text-sm leading-relaxed text-muted">{s.body}</p>
            </div>
          </li>
        ))}
      </ol>

      <div className="mt-8 flex gap-3">
        <a href="/" className={`${btnPrimary} px-6 py-2.5`}>
          イベントをつくる
        </a>
        <a
          href="/me"
          className="inline-flex items-center justify-center rounded-xl border border-line bg-white px-6 py-2.5 font-medium text-muted transition hover:border-brand/40 hover:text-brand-ink"
        >
          マイ予定
        </a>
      </div>
    </div>
  )
}
